import React from "react";
import { useState } from "react";
import "../Routes/homestyles.css"
import AuthServ from "../services/AuthService"


export default function SignUpForm({ handler }) {
    const [usernameVal, setUsernameValue] = useState()
    const [passVal, setPassVal] = useState()
    const [emailVal, setEmailVal] = useState()
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [message, setMessage] = useState("")

    function handleUserNameChange(e) {
        setUsernameValue(e.target.value)
    }
    function handlePassChange(e) {
        setPassVal(e.target.value)
    }

    function handleEmailChange(e) {
        setEmailVal(e.target.value)
    }


    function handleSubmit(e) {
        if (loading) {
            return
        }
        setLoading(true)
        AuthServ.signup(usernameVal, passVal, emailVal).then(
            res => {
                if (res.status == 201) {
                    setSuccess(true)
                    setMessage(res.message)
                }
                else {
                    setSuccess(false)
                    setMessage(res.message)
                    console.log(res.message)
                }
                setLoading(false)
            }
        )
    }



    return (
        <React.Fragment>
            <input className="inputField" value={usernameVal} placeholder="username" onChange={(event) => { handleUserNameChange(event) }}>
            </input>
            <input className="inputField" value={passVal} type="password" placeholder="password" onChange={(event) => { handlePassChange(event) }}>
            </input>
            <input className="inputField" value={emailVal} placeholder="email" onChange={(event) => { handleEmailChange(event) }}>
            </input>
            <div className="message">{message}</div>
            <button className="inputButton center row" onClick={handleSubmit}>
                {loading ? <div className="spinner"></div> : "Sign Up"}
            </button>
            {success &&
                <div className="overlay">
                    <div className="col center">sign up was successful
                        <button className="overlay-button"onClick={() => { handler("signin") }}>login</button>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}